<template>
  <div>
    <h1>Logout!</h1>
  </div>
</template>
<script>
export default {
  methods: {
    doLogout: function () {
      console.log('logging out')
      console.log('TODO: test and ensure that a CSRF logout does not work')
    }
  },
  beforeMount: function () {
    this.doLogout()
  }
}
</script>
<style>

</style>



// WEBPACK FOOTER //
// src/components/LogoutCallback.vue